export let menuOptions = {
	optionsData: [],
};

export const setter = (props) => {
	menuOptions = {
		...menuOptions,
		...props,
	};
};
